// Class token marking a generated draft's wrapper
export const DRAFT_BOOKMARK = '_ConceptDraftRegion';
